import React from "react";

const Speaker = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="currentColor">
            <path d="M16.2 20.2Q15.65 20.45 15.137 20.075Q14.625 19.7 14.625 19.075Q14.625 18.75 14.8 18.5Q14.975 18.25 15.275 18.15Q17.1 17.35 18.225 15.663Q19.35 13.975 19.35 11.975Q19.35 9.975 18.225 8.287Q17.1 6.6 15.275 5.825Q15 5.7 14.812 5.438Q14.625 5.175 14.625 4.85Q14.625 4.225 15.137 3.862Q15.65 3.5 16.2 3.75Q18.65 4.825 20.125 7.025Q21.6 9.225 21.6 11.975Q21.6 14.725 20.125 16.938Q18.65 19.15 16.2 20.2ZM3.9 15.7Q3.3 15.7 2.85 15.25Q2.4 14.8 2.4 14.2V9.8Q2.4 9.175 2.85 8.737Q3.3 8.3 3.9 8.3H6.775L10.2 4.875Q10.925 4.15 11.838 4.537Q12.75 4.925 12.75 5.925V18.05Q12.75 19.05 11.838 19.438Q10.925 19.825 10.2 19.125L6.775 15.7ZM14.625 16.2V7.775Q16 8.425 16.775 9.55Q17.55 10.675 17.55 12Q17.55 13.3 16.775 14.425Q16 15.55 14.625 16.2Z" />
        </svg>
    );
};

export default Speaker;
